module.exports = __webpack_public_path__ + "img/lv3.da3b9926.png";